import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { TextInput } from '@core/components/Inputs';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { Grid } from '@material-ui/core';
import { Note } from '@material-ui/icons';
import { cancelarAlert } from 'app/services/alerts';
import { fechamentoPeriodoApi } from 'app/services/api/fechamentoPeriodoApi';
import * as Actions from 'app/store/actions';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PeriodoFechadoContext } from '../store/PeriodoFechadoContext';
import { PeriodoFechadoModais } from './PeriodoFechadoModais';

const ModalEditarNotaExplicativa = ({ fetchHistorico }) => {
  const [loading, setLoading] = useContext(PeriodoFechadoContext).loading;
  const [modal, setModal] = useContext(PeriodoFechadoContext).modal;
  const [periodoFechadoNota] = useContext(PeriodoFechadoContext).periodoFechadoNota;

  useReduxLoading(loading);

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  const handleCloseModal = () => {
    const close = () => {
      formik.resetForm(initialValues);
      setModal(false);
    };

    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      fetchHistorico();
      close();
    }
  };

  const initialValues = {
    id: periodoFechadoNota?.id,
    notaExplicativa: periodoFechadoNota?.notaExplicativa,
  };

  const handleSubmit = async () => {
    setLoading(true);
    const params = {};
    params.id = formik.values.id;
    params.notaExplicativa = formik.values.notaExplicativa;

    try {
      const response = await fechamentoPeriodoApi.atualizarNota(params.id, params);

      if (response?.status === 200 || response.status === 201) {
        fetchHistorico();
        showSuccess('Nota explicativa editada com sucesso.');
      }
    } catch (err) {
      console.error(err);
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
      setModal(false);
    }
  };

  const formik = useFormik({
    onSubmit: handleSubmit,
    initialValues,
    validateOnBlur: true,
    validateOnChange: true,
  });

  useEffect(() => {
    formik.resetForm(initialValues);
    // Reset controlado pelo gatilho acima; incluir o formulário/valores reiniciaria o
    // preenchimento enquanto o usuário edita.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periodoFechadoNota]);

  return (
    <SimpleDialog innerScroll open={modal === PeriodoFechadoModais.editarNotaExplicativa} onClose={handleCloseModal}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Nota explicativa',
            icon: <Note />,
            toolbar: (
              <>
                <CancelButton onClick={handleCloseModal}>Cancelar</CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Salvar
                </SaveButton>
              </>
            ),
          }}
          content={
            <>
              <Grid container spacing={3} style={{ justifyContent: 'center', alignItems: 'center' }}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ paddingBottom: 10 }}>
                  <TextInput
                    id="notaExplicativa"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values?.notaExplicativa}
                    fullWidth
                    variant="outlined"
                    maxLength={500}
                    rows={4}
                    multiline
                  />
                </Grid>
              </Grid>
            </>
          }
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default ModalEditarNotaExplicativa;
